import React from 'react';
import KickImage from 'Reuseables/KickImage';
import moment from 'moment';
import { TCountdownTimer } from './definitions';
import IconCloseWhite from 'images/close-button-white.png';
import { useCountdown } from 'Pages/Home/Hooks/useCountdown';
import Styles from './CountdownTimer.module.scss';
import axios from 'axios';
import { API_BASE_URL } from '../../../../../../constants';

export default function CountdownTimer({
  countdown_modal,
  timer,
  setCountdownModalState,
  setTimerData,
}: TCountdownTimer): JSX.Element {
  React.useEffect(() => {
    axios
      .get(`${API_BASE_URL}/timer`)
      .then((res) => res.data.data.data.filter((item) => item.active))
      .then((data) => {
        if (data.length === 0) {
          setCountdownModalState(false);
          return;
        }

        setTimerData(data);

        if (moment().isAfter(moment(data[0].ended_at)) || !data[0].ended_at) {
          setCountdownModalState(false);
        } else {
          setCountdownModalState(true);
        }
      });
  }, []);

  const isStart = moment().isAfter(timer?.start);
  const isEnding = moment().isAfter(timer?.end);
  const [days, hours, minutes, seconds] = useCountdown(
    isStart ? timer?.end : timer?.start,
  );

  const handleCloseCountDown = () => {
    setCountdownModalState(false);
  };

  const goToTerms = () => {
    if (timer.terms_url) window.open(timer.terms_url, '_blank');
    else return;
  };

  const renderCountdown = (
    days: number,
    hours: number,
    minutes: number,
    seconds: number,
  ) => {
    return (
      <span className="countdown">
        <span
          style={{
            marginRight: '0.2em',
            display: 'inline-block',
            marginLeft: '0.2em',
          }}
        >
          {days < 10 ? `0${days}` : days}
        </span>
        <span>:</span>
        <span
          style={{
            marginRight: '0.2em',
            display: 'inline-block',
            marginLeft: '0.2em',
          }}
        >
          {hours < 10 ? `0${hours}` : hours}
        </span>
        <span>:</span>
        <span
          style={{
            marginRight: '0.2em',
            display: 'inline-block',
            marginLeft: '0.2em',
          }}
        >
          {minutes < 10 ? `0${minutes}` : minutes}
        </span>
        <span>:</span>
        <span
          style={{
            marginRight: '0.2em',
            display: 'inline-block',
            marginLeft: '0.2em',
          }}
        >
          {seconds < 10 ? `0${seconds}` : seconds}
        </span>
      </span>
    );
  };

  if (
    countdown_modal &&
    !isEnding &&
    !isNaN(days) &&
    !isNaN(hours) &&
    !isNaN(minutes) &&
    !isNaN(seconds)
  ) {
    return (
      <div className={Styles['wrapper']}>
        <div className={Styles['left-mid-content-wrapper']} onClick={goToTerms}>
          <div className={Styles['text-wrapper']}>
            <p>
              {timer?.title}
              {'. '}
              <span className="countdown-bold"> {timer?.description}. </span>
              <span onClick={goToTerms}>Click for more information.</span>
            </p>
          </div>
        </div>
        <div
          className={Styles['close-container']}
          onClick={handleCloseCountDown}
        >
          <KickImage
            className={Styles['close-icon']}
            src={IconCloseWhite}
            alt="close icon"
          />
        </div>
      </div>
    );
  }

  return <div />;
}
